import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component
export default class FullScreenLoading extends Vue {
  @Prop({ required: true })
  isLoading!: boolean;

  @Prop({ default: 0.46 })
  opacity!: number | string;
}
